import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDHeadlineText,
  FDBodyText, FDTitleText,
} from '@facet-wealth/design';

export default buildFacetDesignOverride()
  .nameOverride(['cfpCustomInsightTitle'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'sm' },
  }, overrideReadOnly)
  .nameOverride(['cfpCustomInsightPlannerDisplayName'], {
    _component: () => FDTitleText,
    _customProps: { size: 'lg' },
  }, overrideReadOnly)
  .nameOverride(['cfpCustomInsightContent'], {
    _component: () => FDBodyText,
  }, overrideReadOnly);
